var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublishedResults({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.143555,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EAEAEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10481_24020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.66 15.5298L16.59 22.5998L12.35 18.3598L13.76 16.9498L16.59 19.7798L22.25 14.1198L23.66 15.5298ZM10 17.9998C10 15.6698 11.02 13.5798 12.62 12.1198L15 14.4998V8.4998H9L11.2 10.6998C9.24 12.5198 8 15.1098 8 17.9998C8 23.1898 11.95 27.4498 17 27.9498V25.9298C13.06 25.4398 10 22.0698 10 17.9998ZM28 17.9998C28 12.8098 24.05 8.5498 19 8.0498V10.0698C22.94 10.5598 26 13.9298 26 17.9998C26 20.3298 24.98 22.4198 23.38 23.8798L21 21.4998V27.4998H27L24.8 25.2998C26.76 23.4798 28 20.8898 28 17.9998Z",
    fill: "#787878"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10481_24020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishedResults);
export default __webpack_public_path__ + "static/media/publishedResults.7d5f9707880f6e5244a1176418c877b5.svg";
export { ForwardRef as ReactComponent };